export default {"src":"/_next/static/media/new-space-yard.49b47276.svg","height":32,"width":30,"blurWidth":0,"blurHeight":0};